import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

function TTSServiceProvidersTable({ providers, onEdit, onDelete }) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Name</th>
                <th>Supports Speed</th>
                <th>Supports Mix</th>
                <th>Supports Emotion</th>
                <th>Supports Pitch</th>
                <th>Edit</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            {providers.map(provider => (
                <ProviderRow provider={provider} key={provider.id} onEdit={onEdit} onDelete={onDelete} />
            ))}
            </tbody>
        </table>
    );
}

function ProviderRow({ provider, onEdit, onDelete }) {
    return (
        <tr>
            <td>{provider.id}</td>
            <td>{provider.name}</td>
            <td>{provider.supportsSpeed ? '✔️ Yes' : '❌ No'}</td>
            <td>{provider.supportsMix ? '✔️ Yes' : '❌ No'}</td>
            <td>{provider.supportsEmotion ? '✔️ Yes' : '❌ No'}</td>
            <td>{provider.supportsPitch ? '✔️ Yes' : '❌ No'}</td>
            <td>
                <FaEdit className="edit-icon" onClick={() => onEdit(provider)}/>
            </td>
            <td>
                <FaTrash className="delete-icon" onClick={() => onDelete(provider.id)}/>
            </td>
        </tr>
    );
}

export default TTSServiceProvidersTable;
